/**
 * The tile-based widget for displaying results on the Search Results pages
 */
function SearchList() {
    //Attach an event handler for when search requests finish
    jQuery(document).on(Search.evtSearchComplete, this.searchComplete.bind(this));

    //Attach an event handler for when the display type changes
    jQuery(document).on("searchFormChangeDisplay", this.searchFormChangeDisplay.bind(this));

    //Attach an event handler for when a mouse hovers over one of the search results
    jQuery(document).on("mouseenter", "#rentals-container .listing", this.evtListingHovered);
}

/**
 * Event triggered when a mouse hovers over one of the listings
 * @param  {Object} evt A mouseenter/mouseover event
 */
SearchList.prototype.evtListingHovered = function(evt) {
    $(this).trigger("unitTileHovered", [ this ]);
};

/**
 * Gradually animates a pan to the top of the search results
 */
SearchList.prototype.scrollToTop = function() {
    jQuery('#search-page-main').animate({
        'scrollTop': 0
    }, 200);
};

/**
 * Called by an event when the search form type changes
 * @param  {Object} evt  The event object
 * @param  {string} type The type of search form being switched to
 */
SearchList.prototype.searchFormChangeDisplay = function(evt, type) {
    this.scrollToTop();
};

/**
 * Executes when a search finishes executing, updating the search form with the results
 * @param  {Object} evt    The event object
 * @param  {Object} res    The results returned from the server
 * @param  {Search} search The populated Search object that initiated the search
 */
SearchList.prototype.searchComplete = function(evt, res, search) {
    this.scrollToTop();

    jQuery("#rentals-container #mod-list").html(res.htmlList);
};

window.SearchList = SearchList;



//////////////////
// WEBPACK FOOTER
// ./src/js/searchResults/SearchList.js
// module id = 6
// module chunks = 0